import React, { useState } from 'react';
import { Modal } from 'antd';
import AuditDetail from 'vl-common/src/components/Audit/AuditDetail';
import { AuditedDetailsCategory, defaultEndDate, defaultStartDate } from 'vl-common/src/components/Audit/auditData';
import AuditDatesPicker from 'vl-common/src/components/Audit/AuditDatesPicker';
import { ModalProps } from 'antd/es/modal';
import { Task } from 'vl-common/src/types';

interface TaskAuditProps extends ModalProps {
  show: boolean;
  selectedTask: Task | undefined;
  onClose: () => void;
}

const TaskAuditModal = ({ show, selectedTask, onClose }: TaskAuditProps) => {
  const [eventsStartDate, setEventsStartDate] = useState(defaultStartDate);
  const [eventsEndDate, setEventsEndDate] = useState(defaultEndDate);
  return (
    <Modal
      open={show}
      onCancel={onClose}
      title="Task Audit"
      data-testid="view-audit-trail-modal"
      width="90%"
      styles={{ body: { padding: '8px 0' } }}
      centered
      keyboard={false}
      footer={[]}
    >
      <AuditDatesPicker
        eventsStartDate={eventsStartDate}
        eventsEndDate={eventsEndDate}
        setEventsStartDate={setEventsStartDate}
        setEventsEndDate={setEventsEndDate}
      />
      <AuditDetail
        id={Number(selectedTask?.task_id)}
        category={AuditedDetailsCategory.tasks}
        start_date={eventsStartDate}
        end_date={eventsEndDate}
      />
    </Modal>
  );
};

export default TaskAuditModal;
